import Navbar from "../navbar/Navbar";
import Footer from "../navbar/Footer";
import './Quote.css';
import emailIcon from "../../assets/Icons/blog-email.png";
import locationIcon from "../../assets/Icons/blog-location.png";
import phoneIcon from "../../assets/Icons/blog-phone.png";
import pdfIcon from "../../assets/Icons/pdfIcon.png";
import socialicon1 from "../../assets/Icons/blue social_facebook_circle.png";
import socialicon2 from "../../assets/Icons/blue social_twitter_circle.png";
import socialicon3 from "../../assets/Icons/bule social_linkedin_circle.png";
import socialicon4 from "../../assets/Icons/blue social_Instagrame_circle.png";
import socialicon5 from "../../assets/Icons/blue social_youtube_circle.png";


import ElectricalBROCHURE from '../../assets/PDF folder/BALCO BROCHURE Electrical.pdf';
import CorporateBROCHURE from '../../assets/PDF folder/BALCO CORPORATE BROCHURE.pdf';
import WaterPipesBROCHURE from '../../assets/PDF folder/BALCO WATER PIPES BROCHURE.pdf';
import BROCHURERevised from '../../assets/PDF folder/Malayalam Brochure  revised.pdf';

import { useState } from "react";

export default function Quote() {

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
      });
    
      const [errors, setErrors] = useState({
        name: '',
        email: '',
        phone: ''
      });
    
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formData,
          [name]: value
        });
        // Clear the corresponding error when user starts typing
        setErrors({
          ...errors,
          [name]: ''
        });
      };
    
      const validateForm = () => {
        let isValid = true;
        const newErrors = {};
    
        if (!formData.name.trim()) {
          newErrors.name = 'Name is required';
          isValid = false;
        }
    
        if (!formData.email.trim()) {
          newErrors.email = 'Email is required';
          isValid = false;
        }
    
        if (!formData.phone.trim()) {
          newErrors.phone = 'Phone number is required';
          isValid = false;
        } else if (!/^\d{10}$/.test(formData.phone.trim())) {
          newErrors.phone = 'Invalid phone number (10 digits required)';
          isValid = false;
        }
    
        setErrors(newErrors);
        return isValid;
      };
    
      const handleSubmit = () => {
        if (validateForm()) {
            const { name, email, phone, message } = formData;
            const mailtoLink = `mailto:shareddrive@balcopipes.in?cc=${email}&subject=Contact Form Submission&body=Name: ${name}%0AEmail: ${email}%0APhone: ${phone}%0AMessage: ${message}`;
            window.location.href = mailtoLink;
        }
      };


      const handleDownload1 = () => {
        const pdfUrl = ElectricalBROCHURE;
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = 'BALCO BROCHURE Electrical.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };

      const handleDownload2 = () => {
        const pdfUrl = CorporateBROCHURE;
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = 'BALCO CORPORATE BROCHURE.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };

      const handleDownload3 = () => {
        const pdfUrl = WaterPipesBROCHURE;
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = 'BALCO WATER PIPES BROCHURE.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };

      const handleDownload4 = () => {
        const pdfUrl = BROCHURERevised;
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = 'BALCO MALAYALAM BROCHURE.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };


      
    return(
        <div style={{background: '#ECECEC'}}>
            <Navbar/>
            <div className="container mb-5">
                <div className="my-4">
                <span className="contact-text text" style={{color:"#004779", fontWeight:"bold"}}>Get In Touch</span>
                <div className="d-flex " style={{alignItems:"center"}}>
                        <div style={{width:"10px", height:"10px",borderRadius:"50%", border: "3px solid #004779"}}></div>
                        <div style={{width:"50px",borderBottom:"1px solid #004779"}}></div>
                        </div>
                    <h2 className="contact-heading heading" style={{color:"black"}}>Get a quote for start <br /> <span className="contact-heading">New Journey</span></h2>             
                </div>
                <div className="row pb-5">
                    <div className="col-lg-6" style={{background:"white"}}>
                        <div className="m-4" style={{border:"1px solid #00000026"}}>
                            <div className="p-5">
                                <div className="row py-3">
                                    <div className="col-md-6">
                                        <input type="text" name="name" value={formData.name} onChange={handleChange}  className="m-2" placeholder="Your Name:*"/>
                                        {errors.name && <span style={{ color: 'red' }} className="m-2">{errors.name}</span>}
                                    </div>
                                    <div className="col-md-6">
                                        <input type="email" name="email" value={formData.email} onChange={handleChange} className="m-2" placeholder="Your EmailID:*"/>
                                        {errors.email && <span style={{ color: 'red' }} className="m-2">{errors.email}</span>}
                                    </div>
                                    <div className="col-md-6">
                                        <input type="tel" name="phone" value={formData.phone} onChange={handleChange} className="m-2" placeholder="Your Phone:*"/>
                                        {errors.phone && <span style={{ color: 'red' }} className="m-2">{errors.phone}</span>}
                                    </div>
                                    {/* <div className="col-md-6">
                                        <input type="text" name="" id="" className="m-2" placeholder="Your Message:*"/>
                                    </div> */}
                                    <div className="col-12">
                                        <textarea className="m-2 w-75" rows="4" name="message" value={formData.message} onChange={handleChange} placeholder="Your Message:*"></textarea>
                                    </div>
                                </div>
                                <div>
                                    <button className="btn btn-gold" type="button" onClick={handleSubmit}><span className="btn-square"></span> Submit Now <i className="bi bi-arrow-up-right ms-2"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="my-4 mx-md-4 px-lg-5 container">
                            <button className="btn btn-gold d-flex my-1 w-100" onClick={handleDownload1} style={{justifyContent:"space-between", alignItems:"center"}}>
                                <span className="contact-text text fw-bold" style={{color:"#004779"}}>Download Electrical Brochure  <br />
                                <span className="contact-text small-text" style={{color:"black"}}>Click here to download .PDF</span></span>
                                <img src={pdfIcon} alt="pdfIcon" className="ms-2" width={25}></img>
                            </button>
                            <button className="btn btn-gold d-flex my-1 w-100" onClick={handleDownload2} style={{justifyContent:"space-between", alignItems:"center"}}>
                                <span className="contact-text text fw-bold" style={{color:"#004779"}}>Download Corporate Brochure<br />
                                <span className="contact-text small-text" style={{color:"black"}}>Click here to download .PDF</span></span>
                                <img src={pdfIcon} alt="pdfIcon" className="ms-2" width={25}></img>
                            </button>
                            <button className="btn btn-gold d-flex my-1 w-100" onClick={handleDownload3} style={{justifyContent:"space-between", alignItems:"center"}}>
                                <span className="contact-text text fw-bold" style={{color:"#004779"}}>Download Water Pipes Brochure <br />
                                <span className="contact-text small-text" style={{color:"black"}}>Click here to download .PDF</span></span>
                                <img src={pdfIcon} alt="pdfIcon" className="ms-2" width={25}></img>
                            </button>
                            <button className="btn btn-gold d-flex my-1 w-100" onClick={handleDownload4} style={{justifyContent:"space-between", alignItems:"center"}}>
                                <span className="contact-text text fw-bold" style={{color:"#004779"}}>Download Malayalam Brochure<br />
                                <span className="contact-text small-text" style={{color:"black"}}>Click here to download .PDF</span></span>
                                <img src={pdfIcon} alt="pdfIcon" className="ms-2" width={25}></img>
                            </button>
                        </div>
                    </div>
                </div>

                <div className="my-4">
                    <h2 className="contact-heading heading" style={{color:"black"}}>Become a BALCO distributor today! <br /> Expand your business!</h2>
                <span className="contact-text text" style={{color:"#004779", fontWeight:"bold"}}>To know more contact us</span>
                <div className="d-flex " style={{alignItems:"center"}}>
                        <div style={{width:"10px", height:"10px",borderRadius:"50%", border: "3px solid #004779"}}></div>
                        <div style={{width:"50px",borderBottom:"1px solid #004779"}}></div>
                        </div>
                </div>
                <div className="row pb-5">
                    <div className="col-lg-6">
                        <div className="">
                            <div className="">
                            <iframe width="100%" height="443px" src="https://www.youtube.com/embed/xjJJORtltH8?si=GXlwzJHdwKZE-6MV" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe> 
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="">
                            <div className="p-2">
                                <span className="contact-text text" style={{color:"#004779", fontWeight:"bold"}}>Contact us</span>
                                <div className="d-flex " style={{alignItems:"center"}}>
                        <div style={{width:"10px", height:"10px",borderRadius:"50%", border: "3px solid #004779"}}></div>
                        <div style={{width:"50px",borderBottom:"1px solid #004779"}}></div>
                        </div>
                                <h2 className="contact-heading heading" style={{color:"black"}}>Have any questions? <br /> <span className="contact-heading">Get In Touch!</span></h2>
                                <p className="contact-text text">Please feel free to reach out. <br/> Contact us for more details.</p>
                                <div>
                                    <div className="contact-subheading subheading"><img src={phoneIcon} alt="emailIcon" /> Phone: <span className="text-black">+91 6235350000</span></div>
                                    <div className="contact-subheading subheading"><img src={phoneIcon} alt="phoneIcon" /> Land Line: <span className="text-black">0475-2223867</span></div>
                                    <div className="contact-subheading subheading"><img src={emailIcon} alt="emailIcon" /> Email: <span className="text-black">info@balcopipes.com</span></div>
                                    <div className="contact-subheading subheading"><img src={locationIcon} alt="emailIcon" /> Specialist: <span className="text-black">Consulting</span></div>
                                </div>
                                <div className='d-flex justify-content-start align-items-center mt-4'>
                                        <a href="https://www.facebook.com/balcopvcpipes/" target='_blank' rel="noopener noreferrer" className='mx-2' ><img src={socialicon1} alt="FaceBook" width={35} height={35}/></a>
                                        <a href="https://www.youtube.com/channel/UC1yGWVTNMK46wn2M5GZPRrA" target='_blank' rel="noopener noreferrer" className='mx-2' ><img src={socialicon5} alt="Youtube" width={35} height={35}/></a>
                                        <a href="https://www.instagram.com/balcopvcpipes/" target='_blank' rel="noopener noreferrer" className='mx-2' ><img src={socialicon4} alt="Instagram" width={35} height={35}/></a>
                                        <a href="https://www.twitter.com/balcopvcpipes" target='_blank' rel="noopener noreferrer" className='mx-2' ><img src={socialicon2} alt="Twitter" width={35} height={35}/></a>
                                        <a href="https://www.linkedin.com/company/balcopipes" target='_blank' rel="noopener noreferrer" className='mx-2' ><img src={socialicon3} alt="linkedin" width={35} height={35}/></a>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    )
}